/**
 * Main application entry point
 * Imports and initializes all components
 */

// Import components
import MainNavigation from './main-navigation.js';
import MobileNavigation from './mobile-navigation.js';
import GradientButton from './gradient-button.js';
import RecentPostsSlider from './recent-posts-slider.js';
import LogoMarquee from './logo-marquee.js';
import CountryTicker from './country-ticker.js';
import FullScreenParallax from './full-screen-parallax.js';
import RelatedNewsSwiper from './related-news-swiper.js';
import MembersListToggle from './members-list-toggle.js';
import MemberTestimonialsSwiper from './member-testimonials-swiper.js';
import TimelineSwiper from './timeline-swiper.js';
import SwiperGallery from './swiper-gallery.js';
import SwiperGalleryLightbox from './swiper-gallery-lightbox.js';
import TableOfContents from './table-of-contents.js';
import ModuleReveal from './module-reveal.js';
import AccordionAnimator from './accordion.js';
import HeaderLogoTransition from './header-logo.js';
import TrackerMap from './tracker-map.js';
import { initShareButton } from './share-button.js';

// Initialize all components when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    new MainNavigation();
    new MobileNavigation();
    new GradientButton();
    new RecentPostsSlider();
    new LogoMarquee();
    new CountryTicker();
    new FullScreenParallax();
    new RelatedNewsSwiper();
    new MembersListToggle();
    new MemberTestimonialsSwiper();
    new TimelineSwiper();
    new SwiperGallery();
    new SwiperGalleryLightbox();
    new TableOfContents();
    new ModuleReveal();
    new AccordionAnimator();
    new HeaderLogoTransition(40);
    new TrackerMap();
    initShareButton();
});
